import logo from "./logo.svg";
import Discount from "./components/Discount/Discount.js";
import "./tailwind.css"
import "./assets/bootstrap/bootstrap4.css";
import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FaqList from "./components/Faq_List/FaqList";
import Form from "./components/Faq_List/Form";
import Table from "./components/Faq_Cat_List/Table";
import Banner from "./components/Banner/Banner";
import Step2 from "./components/AnbarGardani/Step2/Step2";
import Step3 from "./components/AnbarGardani/Step3/Step3";
import AnbargardaniList from "./components/AnbarGardani/List/AnbargardaniList";
import Step1 from "./components/AnbarGardani/Step1/Step1";
import LocationLogTable from "./components/AnbarGardani/Logs/LocationLogs/LocationLogTable";
import ProductLogs from "./components/AnbarGardani/Logs/ProductsLogs/ProductLogs";
import QueueHandler from "./components/QueueHandler/QueueHandler";
import UsersReports from "./components/Reports/UsersReports";
import Permission from "./components/Pages/Permission";
import UserSearch from "./components/UserSearch/UserSearch";
import AllShipping from "./components/Shipping/AllShipping";
import { CreateShipping } from "./components/Shipping/CreateShipping";
import { EditShipping } from "./components/Shipping/EditShipping";
import ReplaceUrl from "./components/ReplaceUrl/ReplaceUrl";
import RfmSetting from "./components/RfmSetting/RfmSetting";
import Success from "./components/CronJobs/Success";
import Failed from "./components/CronJobs/Failed";
import { Rfm } from "./components/Rfm/Rfm";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExcelIndex from "./components/Excel/ExcelIndex.jsx";
import ExcelSellReport from "./components/Excel/ExcelSellReport.jsx";
import Excel from "./components/Excel/Excel.jsx";
import ExcelSellTaxReport from "./components/Excel/ExcelSellTaxReport.jsx";
import ExcelWarehouseReceiptReport from "./components/Excel/ExcelWarehouseReceiptReport.jsx";
import ExcelWarehouseReceiptTaxReport from "./components/Excel/ExcelWarehouseReceiptTaxReport.jsx";
import ProductConflict from "./components/ConflictStock/ProductConflict.jsx";
import PackConflict from "./components/ConflictStock/PackConflict.jsx";
import TaskTime from "./components/TaskTime/TaskTime.jsx";
import Convertible from "./components/Query/Convertible.jsx";
import M from "./components/M/M.jsx";
import PostPrice from "./components/Setting/PostPrice.jsx";
import Orders from "./components/Order/Orders";
import Sidebar from "./components/Sidebar/Sidebar.jsx";
import Sync from "./components/Sync/Sync.jsx";
import AdminBarcode from "./components/AdminBarcode/Table/AdminBarcode.jsx";
import CreateAdminBarcode from "./components/AdminBarcode/Form/CreateAdminBarcode.jsx";
import UpdateAdminBarcode from "./components/AdminBarcode/Form/UpdateAdminBarcode.jsx";
import UserInfo from "./components/User/UserInfo.jsx";
import HomepageClass from "./components/HomepageClass/HomepageClass.jsx";
import Gateway from "./components/gateway/Gateway.jsx";
import SmsLimitDataTable from "./components/SmsLimit/SmsLimitDataTable.jsx";
import BlockedSmsLimit from "./components/SmsLimit/BlockedSmsLimit.jsx";
import SmsSend from "./components/SmsSend/SmsSend.jsx";
import SmsTemplate from "./components/SmsTemplate/SmsTemplate.jsx";
import Packs from "./components/Packs/Packs.jsx";
import CategoryPacks from "./components/Packs/CategoryPacks.jsx";
import OrderCheck from "./components/Order/Check/OrderCheck.jsx";
import FactorChecking from "./components/Order/FactorChecking/FactorChecking.jsx";
import { CategoryShipping } from "./components/Shipping/CategoryShipping.jsx";
import BlockedSmsLimitIp from "./components/SmsLimit/BlockedSmsLimitIp.jsx";
function App() {
    useEffect(() => {
        document.addEventListener('wheel', function (e) {
            if (document.activeElement.type === 'number') {
                e.preventDefault();
            }
        }, { passive: false });
    })
    return (
        <div className={["App", "container-fluid", "p-0"].join(" ")}>


            <ToastContainer />

            <Sidebar>
                <div style={{ zIndex: "100", position: "relative", direction: "rtl" }} className="bg-white">
                    <Routes>
                        <Route path="/admin/convertible" element={<Convertible />} />
                        <Route path="/admin/discount" element={<Discount />} />
                        <Route path="/admin/list" element={<FaqList />} />
                        <Route path="/admin/add" element={<Form />} />
                        <Route path="/admin/edit/:id" element={<Form />} />
                        <Route path="/admin/faq_cat" element={<Table />} />
                        <Route path="/admin/" element={<M />} />
                        <Route path="/admin/banner" element={<Banner />} />
                        <Route path="/admin/user_search" element={<UserSearch />} />
                        <Route path="/admin/replace_url" element={<ReplaceUrl />} />
                        <Route
                            path="/admin/AnbarGardani"
                            element={<AnbargardaniList />}
                        />
                        <Route path="/admin/ag1" element={<Step1 />} />
                        <Route path="/admin/ag2" element={<Step2 />} />
                        <Route path="/admin/ag3" element={<Step3 />} />
                        <Route
                            path="/admin/ag/location_log"
                            element={<LocationLogTable />}
                        />
                        <Route path="/admin/ag/Product_log" element={<ProductLogs />} />
                        <Route path="/admin/user_reports" element={<UsersReports />} />

                        <Route path="/admin/403" element={<Permission />} />
                        <Route path="/admin/rfm/setting" element={<RfmSetting />} />

                        <Route path="/admin/faild_orders" element={<QueueHandler />} />
                        <Route
                            path="/admin/shipping/edit/:id"
                            element={<EditShipping />}
                        />
                        <Route
                            path="/admin/shipping/create"
                            element={<CreateShipping />}
                        />
                        <Route path="/admin/shipping/index" element={<AllShipping />} />
                        <Route path="/admin/rfm" element={<Rfm />} />
                        <Route path="/admin/cronjob/success" element={<Success />} />
                        <Route path="/admin/cronjob/failed" element={<Failed />} />

                        <Route path="/admin/excel/index" element={<Excel />} />
                        <Route path="/admin/excel" element={<ExcelIndex />} />
                        <Route path="/admin/excel/sell-report" element={<ExcelSellReport />} />
                        <Route path="/admin/excel/sell-tax-report" element={<ExcelSellTaxReport />} />
                        <Route path="/admin/excel/warehouse-receipt-report" element={<ExcelWarehouseReceiptReport />} />
                        <Route path="/admin/excel/warehouse-receipt-tax-report" element={<ExcelWarehouseReceiptTaxReport />} />

                        <Route path="/admin/conflict/product" element={<ProductConflict />} />
                        <Route path="/admin/conflict/pack" element={<PackConflict />} />

                        <Route path="/admin/task/time" element={<TaskTime />} />
                        <Route path="/admin/m" element={<M />} />
                        <Route path="/admin/setting" element={<PostPrice />} />

                        <Route path="/admin/orders" element={<Orders />} />
                        <Route path="/admin/sync" element={<Sync />} />

                        <Route path="/admin/admin-barcode" element={<AdminBarcode />} />
                        <Route path="/admin/admin-barcode/edit/:id" element={<UpdateAdminBarcode />} />
                        <Route path="/admin/admin-barcode/create" element={<CreateAdminBarcode />} />
                        <Route
                            path="/admin/u/:username"
                            element={<UserInfo />}
                        />
                        <Route path="/admin/homepage/class" element={<HomepageClass />} />
                        <Route path="/admin/gateway" element={<Gateway />} />
                        <Route path="/admin/sms-limit" element={<SmsLimitDataTable />} />
                        <Route path="/admin/sms-limit/blocked" element={<BlockedSmsLimit />} />
                        <Route path="/admin/sms-limit/blockedIp" element={<BlockedSmsLimitIp />} />

                        <Route path="/admin/sms/template" element={<SmsTemplate />} />
                        <Route path="/admin/sms/send" element={<SmsSend />} />
                        <Route path="/admin/newPrefactor/packs/:id" element={<Packs />} />
                        <Route path="/admin/category/packs" element={<CategoryPacks />} />

                        <Route path="/admin/orders/check" element={<OrderCheck />} />
                        <Route path="/admin/orders/factor_checking_barcode/:id" element={<FactorChecking />} />

                        <Route path="/admin/shipping/category/create" element={<CategoryShipping />} />

                    </Routes>
                </div>
            </Sidebar>
        </div>
    );
}

export default App;
